import { AnyAction } from 'redux';
import { CarEBoxLocation } from '../../types';

import { carsActions } from '../reducer';

export const setSelectedCarEBoxLocation = (
  carEBoxLocation: CarEBoxLocation
): AnyAction => carsActions.setSelectedEBoxLocation(carEBoxLocation);
